"use client";

import { usePathname } from "next/navigation";

import { Footer } from "@/components/layout/Footer";

const isMarketplacePath = (pathname = "") => {
  if (pathname === "/marketplace") return true;
  if (pathname.startsWith("/marketplace/")) return true;

  return false;
};

export function MarketplaceFooterBoundary() {
  const pathname = usePathname();

  if (!isMarketplacePath(pathname)) {
    return null;
  }

  return <Footer variant="marketplace" />;
}
